(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 Variant "Full": 

 All the features, biggest filesize
*/ function $9d998481b0dad3fe$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9d998481b0dad3fe$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9d998481b0dad3fe$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9d998481b0dad3fe$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $e9b7c4456bbf1b23$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $8bfa850c9b09c237$var$extendStatics = function extendStatics1(d, b) {
    $8bfa850c9b09c237$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8bfa850c9b09c237$var$extendStatics(d, b);
};
function $8bfa850c9b09c237$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8bfa850c9b09c237$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8bfa850c9b09c237$export$18ce0697a983be9b = function __assign1() {
    $8bfa850c9b09c237$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8bfa850c9b09c237$export$18ce0697a983be9b.apply(this, arguments);
};
function $8bfa850c9b09c237$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8bfa850c9b09c237$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8bfa850c9b09c237$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8bfa850c9b09c237$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8bfa850c9b09c237$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8bfa850c9b09c237$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $8bfa850c9b09c237$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8bfa850c9b09c237$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8bfa850c9b09c237$export$45d3717a4c69092e(o, m, p);
}
function $8bfa850c9b09c237$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8bfa850c9b09c237$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8bfa850c9b09c237$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8bfa850c9b09c237$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8bfa850c9b09c237$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8bfa850c9b09c237$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8bfa850c9b09c237$export$10c90e4f7922046c(v) {
    return this instanceof $8bfa850c9b09c237$export$10c90e4f7922046c ? (this.v = v, this) : new $8bfa850c9b09c237$export$10c90e4f7922046c(v);
}
function $8bfa850c9b09c237$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $8bfa850c9b09c237$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $8bfa850c9b09c237$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8bfa850c9b09c237$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $8bfa850c9b09c237$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8bfa850c9b09c237$export$19a8beecd37a4c45 === "function" ? $8bfa850c9b09c237$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $8bfa850c9b09c237$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8bfa850c9b09c237$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $8bfa850c9b09c237$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8bfa850c9b09c237$export$45d3717a4c69092e(result, mod, k);
    }
    $8bfa850c9b09c237$var$__setModuleDefault(result, mod);
    return result;
}
function $8bfa850c9b09c237$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8bfa850c9b09c237$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8bfa850c9b09c237$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8bfa850c9b09c237$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


function $b2c9f914348c2e13$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $f301e9a131a639bf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f301e9a131a639bf$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $f301e9a131a639bf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f301e9a131a639bf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $68426998e3b11619$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $72e224a45f2258bd$exports = {};

$72e224a45f2258bd$exports = $72e224a45f2258bd$var$get;
/*
  const obj = {a: {aa: {aaa: 2}}, b: 4};

  get(obj, 'a.aa.aaa'); // 2
  get(obj, ['a', 'aa', 'aaa']); // 2

  get(obj, 'b.bb.bbb'); // undefined
  get(obj, ['b', 'bb', 'bbb']); // undefined

  get(obj.a, 'aa.aaa'); // 2
  get(obj.a, ['aa', 'aaa']); // 2

  get(obj.b, 'bb.bbb'); // undefined
  get(obj.b, ['bb', 'bbb']); // undefined

  get(obj.b, 'bb.bbb', 42); // 42
  get(obj.b, ['bb', 'bbb'], 42); // 42

  get(null, 'a'); // undefined
  get(undefined, ['a']); // undefined

  get(null, 'a', 42); // 42
  get(undefined, ['a'], 42); // 42

  const obj = {a: {}};
  const sym = Symbol();
  obj.a[sym] = 4;
  get(obj.a, sym); // 4
*/ function $72e224a45f2258bd$var$get(obj, propsArg, defaultValue) {
    if (!obj) return defaultValue;
    var props, prop;
    if (Array.isArray(propsArg)) props = propsArg.slice(0);
    if (typeof propsArg == "string") props = propsArg.split(".");
    if ((typeof propsArg === "undefined" ? "undefined" : (0, $e9b7c4456bbf1b23$export$5f0017c582d45a2d)(propsArg)) == "symbol") props = [
        propsArg
    ];
    if (!Array.isArray(props)) throw new Error("props arg must be an array, a string or a symbol");
    while(props.length){
        prop = props.shift();
        if (!obj) return defaultValue;
        obj = obj[prop];
        if (obj === undefined) return defaultValue;
    }
    return obj;
}


var $a4c6bf567c1b63c8$var$_get_localized = function _get_localized(ret, locales) {
    if (typeof ret === "object" && ret !== null) {
        if (typeof ret.names === "object" && typeof locales === "object") for(var i = 0; i < locales.length; i++){
            var locale = locales[i];
            if (ret.names[locale]) return ret.names[locale];
        }
        if (ret.name) return ret.name;
        return "";
    }
    return ret;
};
var $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab = function camelToUnderscore(key) {
    key = key.split(".").map(function(x) {
        if (typeof x !== "string" || typeof x[0] !== "string") return "";
        x = x[0].toLowerCase() + x.slice(1); // to allow "MostSpecificSubdivision"
        x = x.replace(/([A-Z])/g, "_$1").toLowerCase();
        return x;
    }).join(".");
    return key;
};
var $a4c6bf567c1b63c8$var$Record = /*#__PURE__*/ function() {
    "use strict";
    function Record(data, default_locales) {
        (0, $b2c9f914348c2e13$export$2996f80ef42b8419)(this, Record);
        (0, $68426998e3b11619$export$1e71eb4bef00f6b0)(this, "data", {});
        (0, $68426998e3b11619$export$1e71eb4bef00f6b0)(this, "default_locales", []);
        this.data = data || {
            is_empty: true
        };
        this.default_locales = [
            "en"
        ];
        this.default_locales = this._process_locales(default_locales);
    }
    (0, $f301e9a131a639bf$export$d60067ff2358eee8)(Record, [
        {
            key: "get",
            value: function get(prop, default_value) {
                return this.get_with_locales(prop, null, default_value);
            }
        },
        {
            key: "get_raw",
            value: function get_raw(prop) {
                prop = $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab(prop);
                return (0, (/*@__PURE__*/$parcel$interopDefault($72e224a45f2258bd$exports)))(this.data, prop, null);
            }
        },
        {
            key: "has_property",
            value: function has_property(prop) {
                var ret = this._lookup_with_locales(prop, this.default_locales, null);
                return ret !== null;
            }
        },
        {
            key: "_lookup_with_locales",
            value: function _lookup_with_locales(prop, locales) {
                var default_value = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                locales = this._process_locales(locales);
                // Treat pseudo-property 'name' as if it never existed
                if (prop.substr(-5) === ".name") prop = prop.substr(0, prop.length - 5);
                var ret = this.get_raw(prop);
                // Localize property, if possible
                ret = $a4c6bf567c1b63c8$var$_get_localized(ret, locales);
                if (ret === null || ret === "") ret = default_value;
                return ret;
            }
        },
        {
            key: "_process_locales",
            value: function _process_locales(locales) {
                if (typeof locales === "string") locales = [
                    locales
                ];
                if (!Array.isArray(locales) || locales.length === 0) locales = this.default_locales;
                return locales;
            }
        },
        {
            key: "get_with_locales",
            value: function get_with_locales(prop, locales, default_value) {
                var ret = this._lookup_with_locales(prop, locales, default_value);
                if (typeof ret === "object") console.warn('Geolocation IP Detection: The property "' + prop + '" is of type "' + (typeof ret === "undefined" ? "undefined" : (0, $e9b7c4456bbf1b23$export$5f0017c582d45a2d)(ret)) + '", should be string or similar', ret);
                if (typeof ret === "undefined") {
                    console.warn('Geolocation IP Detection: The property "' + prop + '" is not defined, please check spelling or maybe you need a different data source', {
                        data: this.data
                    });
                    return "";
                }
                return ret;
            }
        },
        {
            key: "get_country_iso",
            value: function get_country_iso() {
                var country = this.get("country.iso_code");
                if (country) country = country.substr(0, 2).toLowerCase();
                return country;
            }
        },
        {
            /**
     * Check if there is information available for this IP
     * @returns boolean 
     */ key: "is_empty",
            value: function is_empty() {
                return this.get("is_empty", false);
            }
        },
        {
            /**
     * Get error message, if any
     * @return string Error Message
     */ key: "error",
            value: function error() {
                return this.get_raw("extra.error") || "";
            }
        },
        {
            /**
     * Get the raw data of this object
     * @returns object
     */ key: "serialize",
            value: function serialize() {
                return this.data;
            }
        }
    ]);
    return Record;
}();
var $a4c6bf567c1b63c8$export$2e2bcd8739ae039 = $a4c6bf567c1b63c8$var$Record;


// @see https://gomakethings.com/promise-based-xhr/


var $5115e01e50a35b95$export$699251e5611cc6db = function makeRequest(url) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET";
    // Create the XHR request
    var request = new XMLHttpRequest();
    // Return it as a Promise
    return new Promise(function(resolve, reject) {
        // Setup our listener to process compeleted requests
        request.onreadystatechange = function() {
            // Only run if the request is complete
            if (request.readyState !== 4) return;
            // Process the response
            if (request.status >= 200 && request.status < 300) // If successful
            resolve(request);
            else // If failed
            reject({
                status: request.status,
                statusText: request.statusText,
                request: request
            });
        };
        // Setup our HTTP request
        request.open(method || "GET", url, true);
        // Send the request
        request.send();
    });
};
var $5115e01e50a35b95$export$8fe2eaa78e58529f = function jsonDecodeIfPossible(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return $5115e01e50a35b95$var$createErrorObject("Invalid JSON: " + str);
    }
};
function $5115e01e50a35b95$var$createErrorObject(errorMsg) {
    return {
        is_empty: true,
        extra: {
            error: errorMsg
        }
    };
}
var $5115e01e50a35b95$export$49434baf33460b11 = function() {
    var _ref = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function(url) {
        var method, request, e;
        var _arguments = arguments;
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    method = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "GET";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $5115e01e50a35b95$export$699251e5611cc6db(url, method)
                    ];
                case 2:
                    request = _state.sent();
                    if (!request.responseText || request.responseText === "0") return [
                        2,
                        $5115e01e50a35b95$var$createErrorObject("Got an empty response from server. Did you enable AJAX in the options?")
                    ];
                    return [
                        2,
                        $5115e01e50a35b95$export$8fe2eaa78e58529f(request.responseText)
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        $5115e01e50a35b95$export$8fe2eaa78e58529f(e.request.responseText)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function makeJSONRequest(url) {
        return _ref.apply(this, arguments);
    };
}();


var $9a0f598d59a61a3e$export$1f73f60bdb811cb1 = function setLocalStorage(variable, value, ttl_sec) {
    var data = {
        value: value,
        expires_at: new Date().getTime() + ttl_sec * 1000 / 1
    };
    localStorage.setItem(variable.toString(), JSON.stringify(data));
};
function $9a0f598d59a61a3e$export$720fb0373088e6ec(variable) {
    localStorage.removeItem(variable);
}
var $9a0f598d59a61a3e$export$d3720feff416e85b = function getLocalStorage(variable) {
    var data = null;
    try {
        data = JSON.parse(localStorage.getItem(variable.toString()));
    } catch (e) {
        return null;
    }
    if (data !== null) {
        if (data.expires_at !== null && data.expires_at < new Date().getTime()) localStorage.removeItem(variable.toString());
        else return data.value;
    }
    return null;
};




var $f422a70a3b9c8a83$export$c0c5a36406ccde34 = function() {
    return (0, $9a0f598d59a61a3e$export$d3720feff416e85b)((0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).cookie_name);
};
var $f422a70a3b9c8a83$export$bfae0a1e3adc82ee = function(data, cache_duration) {
    (0, $9a0f598d59a61a3e$export$1f73f60bdb811cb1)((0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).cookie_name, data, cache_duration);
};
var $f422a70a3b9c8a83$var$lastEvaluated = {};
var $f422a70a3b9c8a83$export$88983ef80f4f72ac = function() {
    return $f422a70a3b9c8a83$var$lastEvaluated;
};
var $f422a70a3b9c8a83$export$7bc079f12f70511d = function() {
    $f422a70a3b9c8a83$var$lastEvaluated = $f422a70a3b9c8a83$export$c0c5a36406ccde34();
};
var $f422a70a3b9c8a83$export$5bfd3f24e770e2a9 = function() {
    return new (0, $a4c6bf567c1b63c8$export$2e2bcd8739ae039)($f422a70a3b9c8a83$export$c0c5a36406ccde34(), (0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).default_locales);
};


var $b4ba9c8e7a201193$var$_window_geoip_detect;
var $b4ba9c8e7a201193$export$41c562ebe57d11e2 = (($b4ba9c8e7a201193$var$_window_geoip_detect = window.geoip_detect) === null || $b4ba9c8e7a201193$var$_window_geoip_detect === void 0 ? void 0 : $b4ba9c8e7a201193$var$_window_geoip_detect.options) || {
    ajaxurl: "/wp-admin/admin-ajax.php",
    default_locales: [
        "en"
    ],
    cookie_duration_in_days: 7,
    cookie_name: "geoip-detect-result",
    do_body_classes: false
};
var $b4ba9c8e7a201193$var$ajaxPromise = null;
function $b4ba9c8e7a201193$var$get_info_raw() {
    if (!$b4ba9c8e7a201193$var$ajaxPromise) {
        // Do Ajax Request only once per page load
        var url = $b4ba9c8e7a201193$export$41c562ebe57d11e2.ajaxurl + "?action=geoip_detect2_get_info_from_current_ip";
        $b4ba9c8e7a201193$var$ajaxPromise = (0, $5115e01e50a35b95$export$49434baf33460b11)(url);
        $b4ba9c8e7a201193$var$ajaxPromise.then(function(response) {
            var _response_extra;
            if (response === null || response === void 0 ? void 0 : (_response_extra = response.extra) === null || _response_extra === void 0 ? void 0 : _response_extra.error) console.error("Geolocation IP Detection Error: Server returned an error: " + response.extra.error);
        });
    }
    return $b4ba9c8e7a201193$var$ajaxPromise;
}
function $b4ba9c8e7a201193$var$get_info_cached() {
    return $b4ba9c8e7a201193$var$_get_info_cached.apply(this, arguments);
}
function $b4ba9c8e7a201193$var$_get_info_cached() {
    $b4ba9c8e7a201193$var$_get_info_cached = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function() {
        var response, storedResponse, err, _storedResponse_extra, _response_extra, cache_duration;
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    response = false;
                    storedResponse = false;
                    // 1) Load Info from localstorage cookie cache, if possible
                    if ($b4ba9c8e7a201193$export$41c562ebe57d11e2.cookie_name) {
                        storedResponse = (0, $f422a70a3b9c8a83$export$c0c5a36406ccde34)();
                        if (storedResponse === null || storedResponse === void 0 /* this is the only property that is guarantueed */  ? void 0 : storedResponse.extra) {
                            if (storedResponse.extra.override === true) console.info("Geolocation IP Detection: Using cached response (override)");
                            else console.info("Geolocation IP Detection: Using cached response");
                            return [
                                2,
                                storedResponse
                            ];
                        }
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $b4ba9c8e7a201193$var$get_info_raw()
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.log("Weird: Uncaught error...", err);
                    response = err.responseJSON || err;
                    return [
                        3,
                        4
                    ];
                case 4:
                    // 3) Save info to localstorage cookie cache
                    if ($b4ba9c8e7a201193$export$41c562ebe57d11e2.cookie_name) {
                        ;
                        // Check if Override has been set now
                        storedResponse = (0, $f422a70a3b9c8a83$export$c0c5a36406ccde34)();
                        if ((storedResponse === null || storedResponse === void 0 ? void 0 : (_storedResponse_extra = storedResponse.extra) === null || _storedResponse_extra === void 0 ? void 0 : _storedResponse_extra.override) === true) {
                            console.info("Geolocation IP Detection: Using cached response (override)");
                            return [
                                2,
                                storedResponse
                            ];
                        }
                        cache_duration = $b4ba9c8e7a201193$export$41c562ebe57d11e2.cookie_duration_in_days * 86400;
                        if (response === null || response === void 0 ? void 0 : (_response_extra = response.extra) === null || _response_extra === void 0 ? void 0 : _response_extra.error) cache_duration = 60; // Cache errors only for 1 minute, then try again
                        (0, $f422a70a3b9c8a83$export$bfae0a1e3adc82ee)(response, cache_duration);
                    }
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $b4ba9c8e7a201193$var$_get_info_cached.apply(this, arguments);
}
function $b4ba9c8e7a201193$export$3697bcf53517e83c() {
    return $b4ba9c8e7a201193$var$_get_info.apply(this, arguments);
}
function $b4ba9c8e7a201193$var$_get_info() {
    $b4ba9c8e7a201193$var$_get_info = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function() {
        var response, record;
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $b4ba9c8e7a201193$var$get_info_cached()
                    ];
                case 1:
                    response = _state.sent();
                    if (typeof response !== "object") {
                        console.error("Geolocation IP Detection Error: Record should be an object, not a " + (typeof response === "undefined" ? "undefined" : (0, $e9b7c4456bbf1b23$export$5f0017c582d45a2d)(response)), response);
                        response = {
                            "extra": {
                                "error": response || "Network error, look at the original server response ..."
                            }
                        };
                    }
                    record = new (0, $a4c6bf567c1b63c8$export$2e2bcd8739ae039)(response, $b4ba9c8e7a201193$export$41c562ebe57d11e2.default_locales);
                    return [
                        2,
                        record
                    ];
            }
        });
    });
    return $b4ba9c8e7a201193$var$_get_info.apply(this, arguments);
}
function $b4ba9c8e7a201193$export$429bb4f54172a307() {
    return $b4ba9c8e7a201193$var$_get_info_minimal.apply(this, arguments);
}
function $b4ba9c8e7a201193$var$_get_info_minimal() {
    $b4ba9c8e7a201193$var$_get_info_minimal = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function() {
        var response;
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $b4ba9c8e7a201193$var$get_info_cached()
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $b4ba9c8e7a201193$var$_get_info_minimal.apply(this, arguments);
}





var $8435f80da3db6af7$exports = {};

$8435f80da3db6af7$exports = $8435f80da3db6af7$var$set;
/*
  var obj1 = {};
  set(obj1, 'a.aa.aaa', 4); // true
  obj1; // {a: {aa: {aaa: 4}}}

  var obj2 = {};
  set(obj2, ['a', 'aa', 'aaa'], 4); // true
  obj2; // {a: {aa: {aaa: 4}}}

  var obj3 = {a: {aa: {aaa: 2}}};
  set(obj3, 'a.aa.aaa', 3); // true
  obj3; // {a: {aa: {aaa: 3}}}

  const obj5 = {a: {}};
  const sym = Symbol();
  set(obj5.a, sym, 7); // true
  obj5; // {a: {Symbol(): 7}}
*/ function $8435f80da3db6af7$var$set(obj, propsArg, value) {
    var props, lastProp;
    if (Array.isArray(propsArg)) props = propsArg.slice(0);
    if (typeof propsArg == "string") props = propsArg.split(".");
    if ((typeof propsArg === "undefined" ? "undefined" : (0, $e9b7c4456bbf1b23$export$5f0017c582d45a2d)(propsArg)) == "symbol") props = [
        propsArg
    ];
    if (!Array.isArray(props)) throw new Error("props arg must be an array, a string or a symbol");
    lastProp = props.pop();
    if (!lastProp) return false;
    $8435f80da3db6af7$var$prototypeCheck(lastProp);
    var thisProp;
    while(thisProp = props.shift()){
        $8435f80da3db6af7$var$prototypeCheck(thisProp);
        if (typeof obj[thisProp] == "undefined") obj[thisProp] = {};
        obj = obj[thisProp];
        if (!obj || typeof obj != "object") return false;
    }
    obj[lastProp] = value;
    return true;
}
function $8435f80da3db6af7$var$prototypeCheck(prop) {
    // coercion is intentional to catch prop values like `['__proto__']`
    if (prop == "__proto__" || prop == "constructor" || prop == "prototype") throw new Error("setting of prototype values not supported");
}




var $d73968d8a0a066f2$export$2e2bcd8739ae039 = $d73968d8a0a066f2$var$compare;
/*
  primitives: value1 === value2
  functions: value1.toString == value2.toString
  arrays: if length, sequence and values of properties are identical
  objects: if length, names and values of properties are identical
  compare([[1, [2, 3]], [[1, [2, 3]]); // true
  compare([[1, [2, 3], 4], [[1, [2, 3]]); // false
  compare({a: 2, b: 3}, {a: 2, b: 3}); // true
  compare({a: 2, b: 3}, {b: 3, a: 2}); // true
  compare({a: 2, b: 3, c: 4}, {a: 2, b: 3}); // false
  compare({a: 2, b: 3}, {a: 2, b: 3, c: 4}); // false
  compare([[1, [2, {a: 4}], 4], [[1, [2, {a: 4}]]); // true
*/ function $d73968d8a0a066f2$var$compare(value1, value2) {
    if (value1 === value2) return true;
    /* eslint-disable no-self-compare */ // if both values are NaNs return true
    if (value1 !== value1 && value2 !== value2) return true;
    if ((typeof value1 === "undefined" ? "undefined" : (0, $e9b7c4456bbf1b23$export$5f0017c582d45a2d)(value1)) != (typeof value2 === "undefined" ? "undefined" : (0, $e9b7c4456bbf1b23$export$5f0017c582d45a2d)(value2)) || // primitive != primitive wrapper
    ({}).toString.call(value1) != ({}).toString.call(value2) // check for other (maybe nullish) objects
    ) return false;
    if (value1 !== Object(value1)) // non equal primitives
    return false;
    if (!value1) return false;
    if (Array.isArray(value1)) return $d73968d8a0a066f2$var$compareArrays(value1, value2);
    if (({}).toString.call(value1) == "[object Set]") return $d73968d8a0a066f2$var$compareArrays(Array.from(value1), Array.from(value2));
    if (({}).toString.call(value1) == "[object Object]") return $d73968d8a0a066f2$var$compareObjects(value1, value2);
    return $d73968d8a0a066f2$var$compareNativeSubtypes(value1, value2);
}
function $d73968d8a0a066f2$var$compareNativeSubtypes(value1, value2) {
    // e.g. Function, RegExp, Date
    return value1.toString() === value2.toString();
}
function $d73968d8a0a066f2$var$compareArrays(value1, value2) {
    var len = value1.length;
    if (len != value2.length) return false;
    for(var i = 0; i < len; i++){
        if (!$d73968d8a0a066f2$var$compare(value1[i], value2[i])) return false;
    }
    return true;
}
function $d73968d8a0a066f2$var$compareObjects(value1, value2) {
    var keys1 = Object.keys(value1);
    var len = keys1.length;
    if (len != Object.keys(value2).length) return false;
    for(var i = 0; i < len; i++){
        var key1 = keys1[i];
        if (!(value2.hasOwnProperty(key1) && $d73968d8a0a066f2$var$compare(value1[key1], value2[key1]))) return false;
    }
    return true;
}




function $b4d1c184cabe171a$export$25cf4bb9cb194205() {
    return false;
}
var $b4d1c184cabe171a$export$d680cb6eec13a7c7 = new Promise(function(resolve) {
    if ($b4d1c184cabe171a$export$25cf4bb9cb194205()) resolve();
    if (document.readyState === "loading") {
        if (document.addEventListener) document.addEventListener("DOMContentLoaded", resolve);
        else document.attachEvent("onreadystatechange", function() {
            if (document.readyState != "loading") resolve();
        });
    } else resolve();
});
function $b4d1c184cabe171a$export$a5deb02d4df4db34(el, value) {
    for(var i = 0; i < el.options.length; i++)if (el.options[i].value === value) {
        el.selectedIndex = i;
        return true;
    }
    return false;
}
function $b4d1c184cabe171a$export$212ec54c5d687e78(el, attributeName, attributeValue) {
    for(var i = 0; i < el.options.length; i++)if (el.options[i].getAttribute(attributeName) === attributeValue) {
        el.selectedIndex = i;
        return true;
    }
    return false;
}





function $e41b329f42db23c8$export$aafcad1af8162002(el) {
    var raw = el.getAttribute("data-options");
    try {
        return JSON.parse(raw);
    } catch (e) {
        return {};
    }
}
function $e41b329f42db23c8$export$bb8a045c548d38f9(className, errorMessage, callback) {
    return $e41b329f42db23c8$var$_action_on_elements.apply(this, arguments);
}
function $e41b329f42db23c8$var$_action_on_elements() {
    $e41b329f42db23c8$var$_action_on_elements = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function(className, errorMessage, callback) {
        var elements, record;
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    elements = document.getElementsByClassName(className);
                    if (!elements.length) return [
                        2
                    ];
                    return [
                        4,
                        (0, $b4ba9c8e7a201193$export$3697bcf53517e83c)()
                    ];
                case 1:
                    record = _state.sent();
                    if (record.error()) {
                        console.error("Geolocation IP Detection Error (" + errorMessage + "): " + record.error());
                        return [
                            2
                        ];
                    }
                    Array.from(elements).forEach(function(el) {
                        return callback(el, record);
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return $e41b329f42db23c8$var$_action_on_elements.apply(this, arguments);
}
function $e41b329f42db23c8$export$2bcc52ba6c088b4a(el, record) {
    var property = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var opt = $e41b329f42db23c8$export$aafcad1af8162002(el);
    property = property || opt.property;
    if (opt.skip_cache) console.warn("Geolocation IP Detection: The property 'skip_cache' is ignored in AJAX mode. You could disable the response caching on the server by setting the constant GEOIP_DETECT_READER_CACHE_TIME.");
    return record.get_with_locales(property, opt.lang, opt.default);
}


var $3f68aa62fc033904$var$_internalEvent = false;
function $3f68aa62fc033904$export$b27ccd6cf6073c1c() {
    return $3f68aa62fc033904$var$_internalEvent;
}
function $3f68aa62fc033904$export$f0ffca0e7194bd91(el, eventName) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    $3f68aa62fc033904$var$_internalEvent = true;
    var event;
    if (window.CustomEvent && typeof window.CustomEvent === "function") event = new CustomEvent(eventName, {
        detail: options
    });
    else {
        // Compat for IE
        event = document.createEvent("CustomEvent");
        event.initCustomEvent(eventName, true, true, options);
    }
    el.dispatchEvent(event);
    $3f68aa62fc033904$var$_internalEvent = false;
}




var $7944654ce2dd9d65$var$_listener_active = false; // for recursion detection (maybe remove later)
var $7944654ce2dd9d65$var$_change_counter = 0;
function $7944654ce2dd9d65$export$887b871aa5aacaaa() {
    $7944654ce2dd9d65$var$_change_counter++;
    if ($7944654ce2dd9d65$var$_listener_active || $7944654ce2dd9d65$var$_change_counter > 10) {
        console.warn("Error: Thats weird! autosave change detected a recursion (" + $7944654ce2dd9d65$var$_change_counter + ")! Please file a bug report about this and include the first 10 lines of the callstack below:");
        console.trace();
        return false;
    }
    $7944654ce2dd9d65$var$_listener_active = true;
    return true;
}
function $7944654ce2dd9d65$export$f60ab07833116193() {
    $7944654ce2dd9d65$var$_listener_active = false;
}





function $3bb001785c092908$export$2cd8252107eb640b() {
    document.addEventListener("change", $3bb001785c092908$var$event_listener_autosave_on_change, false);
}
function $3bb001785c092908$var$event_listener_autosave_on_change(event) {
    if ((0, $3f68aa62fc033904$export$b27ccd6cf6073c1c)()) return;
    var target = event.target;
    if ((target === null || target === void 0 ? void 0 : target.matches) && target.matches(".js-geoip-detect-input-autosave")) $3bb001785c092908$export$be51a27c79b931de(target);
}
function $3bb001785c092908$export$be51a27c79b931de(el) {
    var property = (0, $e41b329f42db23c8$export$aafcad1af8162002)(el).property;
    var value = el.value;
    if (!(0, $7944654ce2dd9d65$export$887b871aa5aacaaa)()) return;
    if (el.matches("select.js-geoip-detect-country-select")) {
        var selected = el.options[el.selectedIndex];
        var isoCode = selected === null || selected === void 0 ? void 0 : selected.getAttribute("data-c");
        (0, $03d6c28e95082604$export$38a0b31e9febbbe1)("country.iso_code", isoCode.toUpperCase(), {
            reevaluate: false
        });
    }
    (0, $03d6c28e95082604$export$38a0b31e9febbbe1)(property, value, {
        reevaluate: true
    }); // might call do_shortcodes etc.
    (0, $7944654ce2dd9d65$export$f60ab07833116193)();
}


function $ddb23fab3c6f4620$export$c5bfd938fb7f5403(el, record) {
    el.innerText = (0, $e41b329f42db23c8$export$2bcc52ba6c088b4a)(el, record);
}
function $ddb23fab3c6f4620$export$67c46edf2422701b(el, record) {
    var country = record.get_country_iso() || (0, $e41b329f42db23c8$export$aafcad1af8162002)(el).default;
    if (country) el.classList.add("flag-icon-" + country);
}
function $ddb23fab3c6f4620$export$8b2cf4a2576ea856(el, record) {
    var country = record.get_country_iso();
    if ((0, $b4d1c184cabe171a$export$212ec54c5d687e78)(el, "data-c", country)) {
        (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(el, "change");
        return;
    }
    // The country is not the list of countries - select empty option instead
    if ((0, $b4d1c184cabe171a$export$212ec54c5d687e78)(el, "data-c", "")) (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(el, "change");
}
function $ddb23fab3c6f4620$export$46eed00f10e80dd5(el, record) {
    el.value = (0, $e41b329f42db23c8$export$2bcc52ba6c088b4a)(el, record);
    (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(el, "change");
}




var $24387ff8da31158e$exports = {};
$24387ff8da31158e$exports = $24387ff8da31158e$var$intersect;
/*
  intersect([1, 2, 5, 6], [2, 3, 5, 6]); // [2, 5, 6]
  intersect([1, 2, 2, 4, 5], [3, 2, 2, 5, 7]); // [2, 5]
*/ function $24387ff8da31158e$var$intersect(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) throw new Error("expected both arguments to be arrays");
    var result = [];
    var set = $24387ff8da31158e$var$convertArrayToSet(arr2);
    var memo = {};
    for(var i = 0; i < arr1.length; i++){
        var item = arr1[i];
        if (set.hasOwnProperty(item) && !memo.hasOwnProperty(item)) {
            result.push(item);
            memo[item] = true;
        }
    }
    return result;
}
function $24387ff8da31158e$var$convertArrayToSet(arr) {
    var output = {};
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        if (!output.hasOwnProperty(item)) output[item] = true;
    }
    return output;
}


function $34cfab0a14aff422$export$7f72d39cfa7a0f7a(el, record) {
    var opt = (0, $e41b329f42db23c8$export$aafcad1af8162002)(el);
    var evaluated = $34cfab0a14aff422$export$626a13a1fe51c67a(opt.parsed, opt, record);
    if (!evaluated) {
        el.style.display = "none";
        el.classList.add("geoip-hidden");
        el.classList.remove("geoip-shown");
    } else {
        el.style.display = "";
        el.classList.remove("geoip-hidden");
        el.classList.add("geoip-shown");
    }
}
function $34cfab0a14aff422$export$626a13a1fe51c67a(parsed, opt, record) {
    var alternativePropertyNames = [
        "name",
        "iso_code",
        "iso_code3",
        "code",
        "geoname_id"
    ];
    var isConditionMatching = parsed.op === "or" ? false : true;
    parsed.conditions.forEach(function(c) {
        var subConditionMatching = false;
        var values = [];
        var raw_value = record.get_raw(c.p);
        if (raw_value === null) subConditionMatching = false;
        else if (typeof raw_value === "object") alternativePropertyNames.forEach(function(name) {
            if (raw_value[name]) values.push(raw_value[name]);
            else if (name == "name") values.push(record.get_with_locales(c.p, opt.lang));
        });
        else values = [
            raw_value
        ];
        subConditionMatching = $34cfab0a14aff422$var$geoip_detect2_shortcode_check_subcondition(c.v, values);
        if (c.not) subConditionMatching = !subConditionMatching;
        if (parsed.op === "or") isConditionMatching = isConditionMatching || subConditionMatching;
        else isConditionMatching = isConditionMatching && subConditionMatching;
    });
    if (parsed.not) isConditionMatching = !isConditionMatching;
    return isConditionMatching;
}
function $34cfab0a14aff422$var$geoip_detect2_shortcode_check_subcondition(expectedValues, actualValues) {
    if (actualValues[0] === true) actualValues = [
        "true",
        "yes",
        "y",
        "1"
    ];
    else if (actualValues[0] === false) actualValues = [
        "false",
        "no",
        "n",
        "0",
        ""
    ];
    actualValues = actualValues.map(function(x) {
        return String(x).toLowerCase();
    });
    expectedValues = expectedValues.split(",");
    if (expectedValues.indexOf("") !== -1) {
        if (actualValues.length === 0) return true;
    }
    var intersect = (0, (/*@__PURE__*/$parcel$interopDefault($24387ff8da31158e$exports)))(expectedValues, actualValues);
    return intersect.length > 0;
}


var $9cee2e12fa11ef69$export$7481777ea0ea965d = function do_shortcodes_init() {
    (0, $3bb001785c092908$export$2cd8252107eb640b)();
};
var $9cee2e12fa11ef69$export$42610705290faf95 = function() {
    var _do_shortcodes = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function() {
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Before doing any of these, the DOM tree needs to be loaded
                    return [
                        4,
                        (0, $b4d1c184cabe171a$export$d680cb6eec13a7c7)
                    ];
                case 1:
                    _state.sent();
                    // These are called in parallel, as they are async functions
                    (0, $e41b329f42db23c8$export$bb8a045c548d38f9)("js-geoip-detect-shortcode", "could not execute shortcode(s) [geoip_detect2 ...]", (0, $ddb23fab3c6f4620$export$c5bfd938fb7f5403));
                    (0, $e41b329f42db23c8$export$bb8a045c548d38f9)("js-geoip-detect-flag", "could not configure the flag(s)", (0, $ddb23fab3c6f4620$export$67c46edf2422701b));
                    (0, $e41b329f42db23c8$export$bb8a045c548d38f9)("js-geoip-text-input", "could not set the value of the text input field(s)", (0, $ddb23fab3c6f4620$export$46eed00f10e80dd5));
                    (0, $e41b329f42db23c8$export$bb8a045c548d38f9)("js-geoip-detect-country-select", "could not set the value of the select field(s)", (0, $ddb23fab3c6f4620$export$8b2cf4a2576ea856));
                    (0, $e41b329f42db23c8$export$bb8a045c548d38f9)("js-geoip-detect-show-if", "could not execute the show-if/hide-if conditions", (0, $34cfab0a14aff422$export$7f72d39cfa7a0f7a));
                    return [
                        2
                    ];
            }
        });
    });
    function do_shortcodes() {
        return _do_shortcodes.apply(this, arguments);
    }
    return do_shortcodes;
}();






function $73929a6ea3471960$export$fd37e2b9d7d82468(record) {
    return {
        country: record.get("country.iso_code"),
        "country-is-in-european-union": record.get("country.is_in_european_union", false),
        continent: record.get("continent.code"),
        province: record.get("most_specific_subdivision.iso_code"),
        city: record.get("city.names.en")
    };
}
function $73929a6ea3471960$var$remove_css_classes_by_prefix(el, prefix) {
    var classes = el.className.split(" ").filter(function(c) {
        return !c.startsWith(prefix);
    });
    el.className = classes.join(" ").trim();
}
function $73929a6ea3471960$export$69cfbde487906451() {
    return $73929a6ea3471960$var$_add_body_classes.apply(this, arguments);
}
function $73929a6ea3471960$var$_add_body_classes() {
    $73929a6ea3471960$var$_add_body_classes = (0, $9d998481b0dad3fe$export$7c398597f8905a1)(function() {
        var record;
        return (0, $8bfa850c9b09c237$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $b4ba9c8e7a201193$export$3697bcf53517e83c)()
                    ];
                case 1:
                    record = _state.sent();
                    if (record.error()) {
                        console.error("Geolocation IP Detection Error (could not add CSS-classes to body): " + record.error());
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        (0, $b4d1c184cabe171a$export$d680cb6eec13a7c7)
                    ];
                case 2:
                    _state.sent();
                    $73929a6ea3471960$export$4e7274a5cb77ccb6(record);
                    return [
                        2
                    ];
            }
        });
    });
    return $73929a6ea3471960$var$_add_body_classes.apply(this, arguments);
}
// ported from Wordpress PHP
function $73929a6ea3471960$var$sanitize_html_class(string) {
    string = string + "";
    string = string.replace(/%[a-fA-F0-9][a-fA-F0-9]/g, "");
    string = string.replace(/[^A-Za-z0-9_-]/g, "");
    return string;
}
function $73929a6ea3471960$export$4e7274a5cb77ccb6(record) {
    var css_classes = $73929a6ea3471960$export$fd37e2b9d7d82468(record);
    var body = document.getElementsByTagName("body")[0];
    // Remove old classes in case there are any
    $73929a6ea3471960$var$remove_css_classes_by_prefix(body, "geoip-");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(css_classes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = $73929a6ea3471960$var$sanitize_html_class(css_classes[key]);
            if (value) {
                if (typeof value == "string") body.classList.add("geoip-".concat(key, "-").concat(value));
                else body.classList.add("geoip-".concat(key));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}




var $b016e4ccc3c135fb$var$firstCall = true;
function $b016e4ccc3c135fb$export$f22da7240b7add18() {
    if ($b016e4ccc3c135fb$var$firstCall) {
        (0, $9cee2e12fa11ef69$export$7481777ea0ea965d)();
        $b016e4ccc3c135fb$var$firstCall = false;
    }
    if ((0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).do_body_classes) (0, $73929a6ea3471960$export$69cfbde487906451)();
    // Do all the shortcodes that are in the HTML. Even if shortcodes is not enabled globally, they might be enabled for a specific shortcode.
    (0, $9cee2e12fa11ef69$export$42610705290faf95)();
    (0, $f422a70a3b9c8a83$export$7bc079f12f70511d)();
}



function $03d6c28e95082604$var$processOptions(options) {
    options = options || {};
    if (typeof options == "number") options = {
        "duration_in_days": options
    };
    options.duration_in_days = options.duration_in_days || (0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).cookie_duration_in_days;
    if (options.duration_in_days < 0) {
        console.warn("Geolocation IP Detection set_override_data() did nothing: A negative duration doesn't make sense. If you want to remove the override, use remove_override() instead.");
        return false;
    }
    if (typeof options.reevaluate == "undefined") options.reevaluate = true;
    return options;
}
function $03d6c28e95082604$var$changeRecord(record, property, value) {
    record = record || {};
    property = property || "";
    property = (0, $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab)(property);
    var oldData = (0, (/*@__PURE__*/$parcel$interopDefault($72e224a45f2258bd$exports)))(record, property);
    if (typeof oldData == "object" && typeof oldData.names == "object") property += ".name";
    if (property.endsWith(".name")) {
        property += "s"; // e.g. country.name -> country.names
        value = {
            "en": value
        };
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8435f80da3db6af7$exports)))(record, property, value);
    return record;
}
function $03d6c28e95082604$export$38a0b31e9febbbe1(property, value, options) {
    var record = (0, $f422a70a3b9c8a83$export$c0c5a36406ccde34)();
    record = $03d6c28e95082604$var$changeRecord(record, property, value);
    $03d6c28e95082604$export$c3c74383dfd15775(record, options);
}
function $03d6c28e95082604$export$c3c74383dfd15775(record, options) {
    options = $03d6c28e95082604$var$processOptions(options);
    if (record && typeof record.serialize === "function") record = record.serialize();
    return $03d6c28e95082604$var$set_override_data(record, options);
}
function $03d6c28e95082604$var$set_override_data(newData, options) {
    newData = newData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($8435f80da3db6af7$exports)))(newData, "extra.override", true);
    (0, $9a0f598d59a61a3e$export$1f73f60bdb811cb1)((0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).cookie_name, newData, options.duration_in_days * 86400);
    if (options.reevaluate && !(0, $d73968d8a0a066f2$export$2e2bcd8739ae039)(newData, (0, $f422a70a3b9c8a83$export$88983ef80f4f72ac)())) {
        (0, $b016e4ccc3c135fb$export$f22da7240b7add18)();
        return true;
    }
    return false;
}
function $03d6c28e95082604$export$cacb6011bc19db0b(options) {
    options = $03d6c28e95082604$var$processOptions(options);
    (0, $9a0f598d59a61a3e$export$1f73f60bdb811cb1)((0, $b4ba9c8e7a201193$export$41c562ebe57d11e2).cookie_name, {}, -1);
    if (options.reevaluate) (0, $b016e4ccc3c135fb$export$f22da7240b7add18)();
    return true;
}



// Evaluate shortcodes, body classes, etc.
(0, $b016e4ccc3c135fb$export$f22da7240b7add18)();
// Extend window object 
window.geoip_detect.get_info = (0, $b4ba9c8e7a201193$export$3697bcf53517e83c);
window.geoip_detect.set_override = (0, $03d6c28e95082604$export$c3c74383dfd15775);
window.geoip_detect.set_override_with_merge = (0, $03d6c28e95082604$export$38a0b31e9febbbe1);
window.geoip_detect.remove_override = (0, $03d6c28e95082604$export$cacb6011bc19db0b);

})();
//# sourceMappingURL=frontend_full.js.map
